<template>
  <div class="chatItem" @click="handleOpenRes">
    <div class="userInfo">
      <img :src="chatItem.avatar || defaultAvatar" alt />
    </div>
    <div class="chatWrap">
      <div class="title">{{ packageObj.name }}</div>
      <div class="packageInfo">
        <img src="@/assets/icons/icon_folder.png"/>
        <div class="info">
          <span class="money">金币：{{packageObj.price}}</span>
          <div class="intro">
            描述：{{packageObj.intro}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
import {Dialog, ImagePreview} from "vant";
import {mapGetters} from "vuex";
import wx from "weixin-js-sdk";
export default {
  name: "ChatPic",
  props:{
    chatItem:{
      type: Object,
      default:{}
    }
  },
  computed:{
    ...mapGetters(["live","userInfo"]),
    packageObj(){
      return JSON.parse(this.chatItem.chatContext)
    }
  },
  data(){
    return{
      defaultAvatar: defaultAvatar
    }
  },
  methods:{
    handleOpenRes(){
      const email = this.userInfo.email;
      if(!email){
        this.$Bus.$emit("triggerOpenRes");
        return;
      }
      Dialog.confirm({
        title: '确认接收资源？',
        message: '本次接收消耗金币'+this.packageObj.price,
      }).then(() => {
        return this.$http.get(`/chat/getResource?resPackageId=${this.packageObj.id}&liveId=${this.live.id}`);
      }).then(res=>{
        if (res.data.isSend) {
          this.$Bus.$emit("refreshCoin");
          this.$toast.success('文件已发送至邮箱！');
        }else{
          wx.miniProgram.navigateTo({
            url: `/pages/wxpay/wxpay?uni=${res.data.orderId}&payType=pay_resource`,
          });
        }
      }).catch(err=>{
        console.log('取消发送');
        this.$toast.fail(err.message);
      })

    }
  }
}
</script>

<style lang="less" scoped>
.chatItem {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px; // 原30px

  .userInfo {
    margin-left: 25px; // 原50px
    img {
      width: 34px; // 原68px
      height: 34px; // 原68px
      border-radius: 50%;
    }
  }

  .chatWrap {
    position: relative;
    border-radius: 7px; // 原13px
    margin-left: 6px; // 原12px
    background-color: #FFF;
    padding: 15px; // 原30px
    width: 230px; // 原460px

    .title {
      color: #062328;
      font-size: 14px; // 原28px
      font-weight: 800;
      border-bottom: 1px solid #e9eae7;
      padding: 5px; // 原10px
    }

    .packageInfo {
      display: flex;
      flex-direction: row;

      img {
        width: 60px; // 原120px
      }

      .info {
        display: flex;
        flex-direction: column;
        padding: 5px 15px; // 原10px 30px

        .money {
          color: red;
          font-size: 12px; // 原24px
          font-weight: 600;
          margin-bottom: 4px; // 原8px
        }

        .intro {
          color: #969799;
          font-size: 11px; // 原22px
        }
      }
    }
  }
}
</style>
